import { cn } from "@/lib/utils";

export type StatusTone = "ok" | "warning" | "danger" | "info" | "neutral";

/** Shape and text carry the meaning too, never colour alone. */
const TONES: Record<StatusTone, { className: string; mark: string }> = {
  ok: { className: "bg-success-soft text-success-foreground", mark: "●" },
  warning: { className: "bg-warning-soft text-warning-foreground", mark: "▲" },
  danger: { className: "bg-destructive-soft text-destructive", mark: "■" },
  info: { className: "bg-info-soft text-info-foreground", mark: "●" },
  neutral: { className: "bg-muted text-muted-foreground", mark: "●" },
};

export function StatusBadge({
  tone = "neutral",
  children,
  className,
}: {
  tone?: StatusTone;
  children: React.ReactNode;
  className?: string;
}) {
  const { className: toneClass, mark } = TONES[tone];

  return (
    <span
      className={cn(
        "inline-flex h-7 items-center gap-1.5 rounded-md px-2.5 text-xs font-semibold",
        toneClass,
        className,
      )}
    >
      <span aria-hidden>{mark}</span>
      {children}
    </span>
  );
}
